<template>
  <router-view></router-view>
  <auto-logout />
</template>
<script>
  import AutoLogout from "@/views/auth/auto-logout/cover.vue";

  export default {
    name: 'App',
    components: {
      AutoLogout
    }
  };
</script>
<style scoped>
  body {
    font-family: "Poppins", sans-serif !important;
  }
</style>
